import React from 'react';
import { Panel, Big } from './parts';

const days = (n) => (n === null || n === undefined ? '—' : `${n} day${n === 1 ? '' : 's'}`);

export const Upgrades = ({ u, test }) => (
  <Panel title="Upgrades" testId="growth-upgrades">
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div className="rounded-xl bg-amber-50 p-4 space-y-3">
        <Big label="Free → Pro" value={u.pro} tone="text-amber-700" testId="growth-pro-upgrades" sub="bought Pro in this period" />
        <div className="text-xs text-slate-600" data-testid="growth-pro-cohort">
          <b>{u.cohort_pro_rate}%</b> of this period's new accounts have bought Pro ({u.cohort_pro})
        </div>
        <div className="text-xs text-slate-600" data-testid="growth-days-to-pro">
          Signup to Pro: <b>{days(u.avg_days_to_pro)}</b> average · {days(u.median_days_to_pro)} median
        </div>
      </div>
      <div className="rounded-xl bg-green-50 p-4 space-y-3">
        <Big label="Added Officials" value={u.officials} tone="text-green-700" testId="growth-officials-upgrades" sub="in this period" />
        <div className="text-xs text-slate-600" data-testid="growth-officials-split">
          From Free <b>{u.officials_from_free}</b> · From Pro <b>{u.officials_from_pro}</b>
        </div>
        <div className="text-xs text-slate-600" data-testid="growth-officials-cohort">
          <b>{u.cohort_officials_rate}%</b> of this period's new accounts have added Officials ({u.cohort_officials})
        </div>
      </div>
    </div>
    <p className="text-xs text-slate-400 mt-4">Counts paid card and PayPal purchases. "From Free" includes the Pro + Officials bundle. Plans you grant by hand aren't counted.</p>
    {(test.pro > 0 || test.officials > 0) && (
      <p className="text-xs rounded-lg border border-amber-300 bg-amber-50 text-amber-900 px-3 py-2 mt-3" data-testid="growth-test-mode">
        <b>Test mode:</b> {test.pro} simulated Pro and {test.officials} simulated Officials purchases in this period aren't counted.
      </p>
    )}
  </Panel>
);
